import { FormHeader } from '@snsw/react-component-library';
import React from 'react';

const ProgressStepper = ({ stepsList, label = '', title = '' }) => {
  return <FormHeader label={label} stepsList={stepsList} title={title} />;
};

export default ProgressStepper;
